import { MessageCircle } from "lucide-react";
import { Faq } from "../components/Faq";
import { faq, home } from "../content/site";
import { useSupport } from "../lib/support";

/** FAQ из профиля («Дополнительно → FAQ») — те же вопросы, что на главной. */
export function FaqScreen() {
  const support = useSupport();
  return (
    <div className="screen screen--plain">
      <h1 className="screen__title">{home.faqTitle}</h1>
      <p className="screen__subtitle">Частые вопросы о препарате, применении и заказе.</p>
      <Faq items={faq} defaultOpen={0} />
      <button type="button" className="button button--ghost" style={{ marginTop: 20 }} onClick={support.open} disabled={!support.available}>
        <MessageCircle size={17} strokeWidth={1.9} aria-hidden /> {home.bottomCta.button}
      </button>
    </div>
  );
}
